module.exports = __webpack_public_path__ + "img/bs.32666a69.png";